// Convierte el árbol anidado que sirve la API ({ id, name, node_type, children })
// en el formato treeData que consume el componente Tree de antd.
export function buildComponentTree(nodes) {
  if (!Array.isArray(nodes)) return [];
  return nodes.map((n) => ({
    key: n.id,
    title: n.name,
    raw: n,
    children: buildComponentTree(n.children || []),
  }));
}

export default buildComponentTree;
